//hamburger open
$(function () {
  $(".meatballButton").click(function () {
    $(".globalMenu").addClass("active");
    $("body").css("overflow", "hidden");
  });

  $(".meatballCloseButton").click(function () {
    $(".globalMenu").removeClass("active");
    $("body").css("overflow", "auto");
  });

  $(".navItem a").on("click", function () {
    $(".meatballButton").removeClass("active");
    $(".globalMenu").removeClass("active");
  });
});

//arrow hover animation
const arrowLinks = document.querySelectorAll(".c-arrow-link");
if (arrowLinks.length > 0) {
  arrowLinks.forEach((arrowLink) => {
    arrowLink.addEventListener(
      "mouseenter",
      function () {
        arrowLink.classList.add("is-hover");
      },
      {
        once: true,
      }
    );
  });
}

// accordion
$(function () {
  $(".toggleTitle").click(function () {
    $(this).toggleClass("selected");
    $(this).next().toggleClass("selected");
  });
});

// quantity button
$(function () {
  $(document).on("click", "[data-qty-plus]", function () {
    const $wrap = $(this).closest(".quantity-selector");
    const $input = $wrap.find('[data-quantity-input]');
    let currentVal = parseInt($input.val(), 10);
    if (isNaN(currentVal) || currentVal < 1) {
      currentVal = 1;
    }
    $input.val(currentVal + 1).trigger("change");
  });
  $(document).on("click", "[data-qty-minus]", function () {
    const $wrap = $(this).closest(".quantity-selector");
    const $input = $wrap.find('[data-quantity-input]');
    let currentVal = parseInt($input.val(), 10);
    if (isNaN(currentVal) || currentVal <= 1) {
      currentVal = 1;
    } else {
      currentVal = currentVal - 1;
    }
    $input.val(currentVal).trigger("change");
  });

  $(document).on("input", '[data-quantity-input]', function () {
    let currentVal = parseInt($(this).val(), 10);
    if (isNaN(currentVal) || currentVal < 1) {
      $(this).val(1);
    }
  });
});

// buy now
$(function () {
  $(document).on("click", "[data-buy-now]", function (e) {
    e.preventDefault();
    var $button = $(this);
    var $form = $button.closest('form[action*="/cart/add"]');
    if (!$form.length) return;
    var formData = new FormData($form[0]);
    $button.prop("disabled", true).text("処理中...");
    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      credentials: "same-origin"
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("カート追加に失敗しました");
        }
        return response.json();
      })
      .then(function () {
        window.location.href = "/checkout";
      })
      .catch(function (error) {
        console.error(error);
        alert("購入処理に失敗しました");
        $button.prop("disabled", false).text("今すぐ購入する");
      });
  });
});